import { cn } from '@/lib/utils';
import { Link } from '@tanstack/react-router';

export default function Logo({ className }: { className?: string }) {
  return (
    <Link to="/" className={cn('w-20 md:w-44 max-w-44', className)}>
      <img src="/images/logo2.png" alt="Logo" className="w-full" />
    </Link>
  );
}
